import React, { PureComponent } from 'react';

import { Button } from '@mui/material';

import { getCurrentMission } from '../../../dataModelHelpers';
import { alertError, alertInfo } from '../../../alertDispatcher';
import { OnLoading } from '../../../types/types';
import { CloudUploadOutlined } from '@mui/icons-material';
import { importPolygonsFromXagFolder } from '../../../services/XagBoundariesImporter';

interface UploadXagButtonProps {
  text?: string;
  onLoading: OnLoading;
}

export default class UploadXagButton extends PureComponent<UploadXagButtonProps> {
  fileInput: React.LegacyRef<HTMLInputElement>;
  reader: FileReader;

  constructor(props: UploadXagButtonProps) {
    super(props);

    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleFileReadKml = this.handleFileReadKml.bind(this);
    this.fileInput = React.createRef();
    this.reader = new FileReader();
  }

  async handleFileReadKml() {
    const mission = getCurrentMission();

    if (!mission) {
      return;
    }

    const result = this.reader.result;

    const isString = (data: string | ArrayBuffer | null): data is string => {
      return typeof result === 'string';
    };

    if (!isString(result)) {
      alertError(`Error: file is NOT the right format`);

      return;
    }

    // Remove old zones with boundaries
    mission.getZones().forEach((zone) => zone.dispose());

    // Create new ones
    await importPolygonsFromXagFolder(result, mission);

    alertInfo('XAG boundaries import completed');
  }

  async handleFileUpload(event: React.ChangeEvent<HTMLInputElement>) {
    const uploadFile = event.target.files![0];

    if (!uploadFile.name.endsWith('kml')) {
      return;
    }

    this.reader.onloadend = this.handleFileReadKml;
    this.reader.readAsText(uploadFile);
  }

  render() {
    return (
      <Button variant="outlined" component="label">
        <CloudUploadOutlined style={{ paddingRight: 7.5 }} />
        Upload XAG
        <input
          type="file"
          accept=".kml"
          style={{ display: 'none' }}
          ref={this.fileInput}
          onChange={this.handleFileUpload}
          multiple={false}
        />
      </Button>
    );
  }
}
